export enum FontAwesome {
  AngleDoubleRight = "Angle Double Right",
  AngleDoubleUp = "Angle Double Up",
  Archive = "Archive",
  ArrowDown = "Arrow Down",
  ArrowLeft = "Arrow Left",
  ArrowRight = "Arrow Right",
  ArrowUp = "Arrow Up",
  Arrows = "Arrows",
  ArrowsHorizontal = "Arrows Horizontal",
  ArrowsVertical = "Arrows Vertical",
  Ban = "Ban",
  Bank = "Bank",
  BarChart = "Bar Chart",
  Binoculars = "Binoculars",
  Book = "Book",
  Briefcase = "Briefcase",
  Building = "Building",
  Bullseye = "Bullseye",
  Calendar = "Calendar",
  CaretDown = "Caret Down",
  CaretRight = "Caret Right",
  CaretUp = "Caret Up",
  Chain = "Chain",
  Check = "Check",
  CheckCircle = "Check Circle",
  CheckSquare = "Check Square",
  CheckSquareOutline = "Check Square Outline",
  ChevronDown = "Chevron Down",
  ChevronRight = "Chevron Right",
  Circle = "Circle",
  CircleOutline = "Circle Outline",
  CircleOutlineNotched = "Circle Outline Notched",
  CircleThin = "Circle Thin",
  ClockOutline = "Clock Outline",
  Clone = "Clone",
  Close = "Close",
  CloudDownload = "Cloud Download",
  Cog = "Cog",
  Cogs = "Cogs",
  Copy = "Copy",
  Crosshairs = "Crosshairs",
  Database = "Database",
  Desktop = "Desktop",
  DotCircleOutline = "Dot Circle Outline",
  Download = "Download",
  Edit = "Edit",
  EllipsisVertical = "Ellipsis Vertical",
  Envelope = "Envelope",
  Eraser = "Eraser",
  Exchange = "Exchange",
  ExclamationCircle = "Exclamation Circle",
  ExclamationTriangle = "Exclamation Triangle",
  ExternalLink = "External Link",
  Eye = "Eye",
  Fax = "Fax",
  FilePdfOutline = "File PDF Outline",
  FilesOutline = "Files Outline",
  FileZipOutline = "File Zip Outline",
  Filter = "Filter",
  FloppyDiskOutline = "Floppy Disk Outline",
  Folder = "Folder",
  Globe = "Globe",
  History = "History",
  Home = "Home",
  IdBadge = "ID Badge",
  InfoCircle = "Info Circle",
  Laptop = "Laptop",
  LineChart = "Line Chart",
  List = "List",
  LocationArrow = "Location Arrow",
  Lock = "Lock",
  LongArrowDown = "Long Arrow Down",
  LongArrowUp = "Long Arrow Up",
  LowVision = "Low Vision",
  Map = "Map",
  MapMarker = "Map Marker",
  MapPin = "Map Pin",
  Minus = "Minus",
  MinusCircle = "Minus Circle",
  ObjectGroup = "Object Group",
  Pencil = "Pencil",
  PencilSquareOutline = "Pencil Square Outline",
  Phone = "Phone",
  Play = "Play",
  Plug = "Plug",
  Plus = "Plus",
  PlusCircle = "Plus Circle",
  Question = "Question",
  QuestionCircle = "Question Circle",
  Refresh = "Refresh",
  Rocket = "Rocket",
  Search = "Search",
  Sellsy = "Sellsy",
  Server = "Server",
  Share = "Share",
  SignIn = "Sign In",
  SignOut = "Sign Out",
  Sliders = "Sliders",
  Sort = "Sort",
  Spinner = "Spinner",
  Square = "Square",
  SquareOutline = "Square Outline",
  Star = "Star",
  Stop = "Stop",
  StopCircle = "Stop Circle",
  StopCircleOutline = "Stop Circle Outline",
  Tag = "Tag",
  Tags = "Tags",
  Tasks = "Tasks",
  ThLarge = "Th Large",
  ThumbsOutlineUp = "Thumbs Outline Up",
  Times = "Times",
  TimesCircle = "Times Circle",
  TimesCircleOutline = "Times Circle Outline",
  TimesLight = "Times Light",
  ToggleOff = "Toggle Off",
  ToggleOn = "Toggle On",
  Trash = "Trash",
  TrashOutline = "Trash Outline",
  Umbrella = "Umbrella",
  University = "University",
  Unlock = "Unlock",
  Upload = "Upload",
  User = "User",
  UserMd = "User MD",
  UserPlus = "User Plus",
  Users = "Users",
  UserTimes = "User Times",
  Wrench = "Wrench",
}

export enum QesIcons {
  AlertHexagon = "Alert Hexagon",
  AlertTriangle = "Alert Triangle",
  AlertTriangleColored = "Alert Triangle Colored",
  AlignLeftV1 = "Align Left v1",
  AlignRightV1 = "Align Right v1",
  Archive = "Archive (Untitled UI)",
  ArrowNarrowDown = "Arrow Narrow Down",
  ArrowNarrowLeft = "Arrow Narrow Left",
  ArrowNarrowRight = "Arrow Narrow Right",
  ArrowNarrowUp = "Arrow Narrow Up",
  ArrowsHorizontal = "Arrows Horizontal (Untitled UI)",
  ArrowsVertical = "Arrows Vertical (Untitled UI)",
  BarChartV7 = "Bar Chart v7",
  BookmarkAdd = "Bookmark Add",
  Briefcase = "Briefcase",
  BuildingV7 = "Building v7",
  Calendar = "Calendar (Untitled UI)",
  Check = "Check (Untitled UI)",
  CheckCircle = "Check Circle (Untitled UI)",
  CheckVerifiedV2 = "Check Verified v2",
  ChevronDown = "Chevron Down (Untitled UI)",
  ChevronLeft = "Chevron Left",
  ChevronRight = "Chevron Right (Untitled UI)",
  ChevronRightDouble = "Chevron Right Double",
  ChevronUp = "Chevron Up",
  ChevronUpDouble = "Chevron Up Double",
  Circle = "Circle (Untitled UI)",
  ClockRewind = "Clock Rewind",
  CopyV7 = "Copy v7",
  CountyMap = "County Map",
  Database = "Database",
  DotsVertical = "DotsVertical",
  Download = "Download",
  DownloadCloudV1 = "Download Cloud v1",
  DragAndDropTexture = "Drag And Drop Texture",
  ExpandV1 = "Expand v1",
  Eye = "Eye (Untitled UI)",
  EyeOff = "Eye Off",
  FileV4 = "File v4",
  FilterLines = "Filter Lines",
  FlagV1 = "Flag v1",
  Folder = "Folder (Untitled UI)",
  GlassesV2 = "Glasses v2",
  GridV1 = "Grid v1",
  Help = "Help",
  HexagonOnEdge = "Hexagon (on Edge)",
  HexagonOnVertex = "Hexagon (on Vertex)",
  HomeV3 = "Home v3",
  InfoCircle = "Info Circle (Untitled UI)",
  LayersThreeV1 = "Layers (3) v1",
  LayersThreeV2 = "Layers (3) v2",
  LayersTwoV1 = "Layers (2) v1",
  LayersTwoV2 = "Layers (2) v2",
  LifeBuoyV1 = "Life Buoy v1",
  LinkV4 = "Link v4",
  List = "List (Untitled UI)",
  LoadingV1 = "Loading v1",
  LockV1 = "Lock v1",
  LogInV1 = "Sign In v1",
  LogOutV1 = "Sign Out v1",
  MailV1 = "Mail v1",
  MapV1 = "Map v1",
  MarkerPinV1 = "Marker Pin v1",
  MarkerPinV6 = "Marker Pin v6",
  MenuV1 = "Menu v1",
  Minus = "Minus",
  MinusCircle = "Minus Circle",
  MinusSquare = "Minus Square",
  PencilV1 = "Pencil v1",
  Pentagon = "Pentagon",
  PhoneV1 = "Phone v1 (Untitled UI)",
  Play = "Play (Untitled UI)",
  Plus = "Plus (Untitled UI)",
  PlusCircle = "Plus Circle (Untitled UI)",
  PlusSquare = "Plus Square",
  PresentationChartV1 = "Presentation Chart v1",
  Printer = "Printer",
  ProviderMapPin = "ProviderMapPin",
  Quinn = "Quinn",
  RefreshCcwV2 = "Refresh CCW v2",
  RocketV2 = "Rocket v2",
  Route = "Route",
  ScissorsV2 = "Scissors v2",
  SearchSm = "Search Small",
  SettingsV2 = "Settings v2",
  ShareV4 = "Share v4",
  ShareV6 = "Share v6",
  SlashOctagon = "Slash Octagon",
  SlidersV4 = "Sliders v4",
  Square = "Square",
  StarV1 = "Star v1",
  SwitchHorizontalV1 = "Switch Horizontal v1",
  SwitchVerticalV1 = "Switch Vertical v1",
  TagV1 = "Tag v1",
  TargetV4 = "Target v4",
  TerminalBrowser = "Terminal Browser",
  ThumbsDown = "Thumbs Down",
  ThumbsUp = "Thumbs Up",
  ToolV2 = "Tool v2",
  Tooth = "Tooth",
  TrashV1 = "Trash v1",
  Unlock = "Unlock (Custom)",
  UploadV1 = "Upload v1",
  UserPlusV1 = "User Plus v1",
  UsersV1 = "Users v1",
  UserV1 = "User v1",
  UserXV1 = "User X v1",
  X = "X",
  XCircle = "X Circle",
  XClose = "X Close",
  Zap = "Zap",
}
